import { render, staticRenderFns } from "./UpsellingCheckoutOption.vue?vue&type=template&id=5949134e&scoped=true"
import script from "./UpsellingCheckoutOption.vue?vue&type=script&lang=js"
export * from "./UpsellingCheckoutOption.vue?vue&type=script&lang=js"
import style0 from "./UpsellingCheckoutOption.vue?vue&type=style&index=0&id=5949134e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5949134e",
  null
  
)

export default component.exports